import { render, staticRenderFns } from "./UploadCustomPDB.vue?vue&type=template&id=b4b825e4&scoped=true&"
import script from "./UploadCustomPDB.vue?vue&type=script&lang=js&"
export * from "./UploadCustomPDB.vue?vue&type=script&lang=js&"
import style0 from "./UploadCustomPDB.vue?vue&type=style&index=0&id=b4b825e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b825e4",
  null
  
)

export default component.exports